import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const DocumentPreparation = () => {
  return (
    <>
      <Helmet>
        <title>Document Preparation Services - Ursus Victor LLC</title>
        <meta name="description" content="Professional loan document preparation and organization services. Get your financial documents ready for loan applications." />
      </Helmet>

      {/* Hero */}
      <section style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: 'white',
        padding: '5rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <div style={{fontSize: '4rem', marginBottom: '1rem'}}>📄</div>
          <h1 style={{fontSize: '3.5rem', fontWeight: '900', marginBottom: '1.5rem'}}>
            Document Preparation Services
          </h1>
          <p style={{fontSize: '1.3rem', opacity: 0.95, lineHeight: '1.7'}}>
            Professional support organizing and preparing all required loan documentation
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section style={{padding: '5rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '1000px', margin: '0 auto'}}>
          <div style={{marginBottom: '4rem'}}>
            <h2 style={{fontSize: '2.5rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1.5rem'}}>
              Complete Document Organization
            </h2>
            <p style={{fontSize: '1.15rem', color: '#475569', lineHeight: '1.9', marginBottom: '1.5rem'}}>
              Proper documentation is critical for loan approval. Our document preparation services help you gather, 
              organize, and present all required financial documents in a professional, lender-ready format. We ensure 
              nothing is missing and everything is properly formatted.
            </p>
            <div style={{
              background: '#fef3c7',
              padding: '1.5rem',
              borderRadius: '12px',
              border: '2px solid #f59e0b'
            }}>
              <p style={{color: '#92400e', fontWeight: '700', margin: 0}}>
                ⚠️ We provide document preparation support only. We are NOT a lender and do NOT make lending decisions.
              </p>
            </div>
          </div>

          {/* Services */}
          <div style={{marginBottom: '4rem'}}>
            <h3 style={{fontSize: '2rem', fontWeight: '800', color: '#1e40af', marginBottom: '2rem'}}>
              Document Services
            </h3>
            <div style={{display: 'grid', gap: '1.5rem'}}>
              {[
                {
                  title: 'Document Checklist Creation',
                  desc: 'Custom checklist of all documents needed for your specific loan type'
                },
                {
                  title: 'Financial Statement Organization',
                  desc: 'Help organizing profit & loss statements, balance sheets, and cash flow statements'
                },
                {
                  title: 'Tax Return Compilation',
                  desc: 'Gathering and organizing personal and business tax returns'
                },
                {
                  title: 'Bank Statement Preparation',
                  desc: 'Proper formatting and presentation of banking records'
                },
                {
                  title: 'Supporting Document Assembly',
                  desc: 'Organizing additional documents like business licenses, contracts, etc.'
                },
                {
                  title: 'Document Verification',
                  desc: 'Ensuring all documents are complete, current, and properly formatted'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: '#f8fafc',
                  padding: '2rem',
                  borderRadius: '12px',
                  border: '2px solid #e2e8f0',
                  borderLeft: '5px solid #3b82f6'
                }}>
                  <h4 style={{fontSize: '1.4rem', fontWeight: '800', color: '#1e40af', marginBottom: '0.75rem'}}>
                    {item.title}
                  </h4>
                  <p style={{color: '#64748b', lineHeight: '1.7', fontSize: '1.05rem'}}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Common Documents */}
          <div style={{marginBottom: '4rem'}}>
            <h3 style={{fontSize: '2rem', fontWeight: '800', color: '#1e40af', marginBottom: '2rem'}}>
              Documents We Help Prepare
            </h3>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '1rem'
            }}>
              {[
                'Tax Returns',
                'Pay Stubs',
                'Bank Statements',
                'W-2 Forms',
                '1099 Forms',
                'Profit & Loss Statements',
                'Balance Sheets',
                'Business Tax Returns',
                'Business Licenses',
                'Articles of Incorporation',
                'Financial Projections',
                'Asset Documentation'
              ].map((doc, index) => (
                <div key={index} style={{
                  padding: '1rem',
                  background: '#f8fafc',
                  borderRadius: '8px',
                  border: '2px solid #e2e8f0',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  fontWeight: '600',
                  color: '#475569'
                }}>
                  <span style={{color: '#3b82f6', fontSize: '1.5rem'}}>✓</span>
                  {doc}
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div style={{
            background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
            padding: '3rem',
            borderRadius: '16px',
            border: '3px solid #3b82f6',
            textAlign: 'center'
          }}>
            <h3 style={{fontSize: '2rem', fontWeight: '900', color: '#1e3a8a', marginBottom: '1rem'}}>
              Need Help With Documentation?
            </h3>
            <p style={{fontSize: '1.15rem', color: '#475569', marginBottom: '2rem', lineHeight: '1.7'}}>
              Let us help you organize and prepare all required documents
            </p>
            <Link to="/contact" style={{
              background: '#1e40af',
              color: 'white',
              padding: '1.25rem 3rem',
              borderRadius: '12px',
              fontWeight: '800',
              fontSize: '1.2rem',
              display: 'inline-block'
            }}>
              Get Document Support
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default DocumentPreparation;
